// extracted by mini-css-extract-plugin
module.exports = {"root":"Consent_root__3L-St","content":"Consent_content__1G22V","footer":"Consent_footer__2irsa"};